import { render, staticRenderFns } from "./UsersDetails.vue?vue&type=template&id=1553a7b3"
import script from "./UsersDetails.vue?vue&type=script&lang=js"
export * from "./UsersDetails.vue?vue&type=script&lang=js"
import style0 from "./UsersDetails.vue?vue&type=style&index=0&id=1553a7b3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports